import '.cg{font-size:1.125rem;}.ssr-plugin'
import '.gf{line-height:1.75rem;}.ssr-plugin'
import '.bv{text-decoration:none;}.ssr-plugin'
import '.eh{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="cg gf"
    >
      {translations.privacySubtitle}{' '}
      <a className="bv eh"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="bv eh"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
